import { EmployeeMasterService } from "@/api/services/masterService";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

// Define types for Employee
interface Employee {
  id: string;
  employeeCode: string;
  name: string;
  mobile: string;
  email: string;
  address1: string;
  address2: string;
  city: string;
  pin: string;
  phone: string;
  designationId: string;
  designationName: string;
  joinDate: string; 
  resignDate: string; 
  branchId: string;
  branchName: string;
  reportingTo: string;
  reportingToName: string;
  status: number; 
}

// Define state type
interface EmployeeMasterState {
  loading: boolean;
  EmployeeList: Employee[];
  error?: string;
}

// Initial state with type safety
const initialState: EmployeeMasterState = {
  loading: false,
  EmployeeList: [],
  error: undefined,
};

// ✅ Fixed Async thunk with proper return type
export const fetchEmployeeMaster = createAsyncThunk<
  Employee[], 
  void, 
  { rejectValue: string }
>(
  "Employee/fetchEmployeeMaster",
  async (_, { rejectWithValue }) => {

    try {
      const response = await EmployeeMasterService.getallEmployeeMaster();

      // If API returns { data: Employee[] }, extract `data`
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch Employee data");
    }
  }
);

// Create slice with strong typing
const EmployeeMasterSlice = createSlice({
  name: "EmployeeMaster",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployeeMaster.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchEmployeeMaster.fulfilled, (state, action: PayloadAction<Employee[]>) => {
        state.EmployeeList = action.payload;
        state.loading = false;
      })
      .addCase(fetchEmployeeMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

// Export reducer
export default EmployeeMasterSlice.reducer;
